export const setUser = (payload) => ({
  type: 'SET_USER',
  payload,
});

export const setPokemons = (payload) => ({
  type: 'SET_POKEMONS',
  payload,
});
export const setMyPokemons = (payload) => ({
  type: 'SET_MY_POKEMONS',
  payload,
});
export const deleteMyPokemons = (payload) => ({
  type: 'DELETE_MY_POKEMONS',
  payload,
});
